/**
 * Metriche della scheda cliente che si calcolano da dati già completi in mano
 * al browser (progetti, comunicazioni).
 *
 * L'ESPOSIZIONE NON STA PIÙ QUI. La sommava questo file scorrendo `c.invoices`,
 * che però sono solo le ultime 20 fatture caricate per la tabella: su un
 * cliente storico quelle 20 sono tutte recenti e tutte pagate, e la scheda
 * annunciava 0 di scaduto a Emmequadro (18.580 reali) e a New Omnia (6.100).
 * Ora il totale lo calcola il server su tutte le fatture e arriva in
 * `invoiceStats` — vedi `clientInvoiceStats` in apps/api/src/modules/clients.
 */

/** Stati progetto considerati "attivi" (stessa definizione del filtro nel tab Progetti). */
export const ACTIVE_PROJECT_STATUSES = ['ATTIVO', 'IN_CORSO', 'REVISIONE'] as const;

export function countActiveProjects(projects: Array<{ status: string }> | null | undefined): number {
  return (projects ?? []).filter((p) => (ACTIVE_PROJECT_STATUSES as readonly string[]).includes(p.status)).length;
}

/** Data dell'ultima comunicazione registrata (null se nessuna). */
export function lastContactDate(
  communications: Array<{ occurredAt: string }> | null | undefined,
): string | null {
  let last: string | null = null;
  for (const c of communications ?? []) {
    if (!last || new Date(c.occurredAt).getTime() > new Date(last).getTime()) last = c.occurredAt;
  }
  return last;
}
